export default function pointsTransform(input) {
  return input.split("").join(".");
}
